import React from 'react';
import icon from 'common/assets/images/smarttinvest-circle-logo.svg';
import Image from './Image';

export default () => <Image src={icon} alt="Logo SmarttInvest" />;
